import React, { useState, useEffect } from "react";
import { UrlApi } from "../../../../services/apirest";
import {
  Button,
  Container,
  Dialog,
  DialogContent,
  Box,
  Grid,
  Stack,
  TextField,
  Snackbar,
  Alert,
  DialogTitle,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";

function EdicionProducto(props) {
  const [editar, setEditar] = useState(props.editar);
  const [datosRow, setDatosRow] = useState(props.datosRow);
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");
  //Snackbar Notificacion
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSnack(false);
    handleClose();
  };

  const handleClose = () => {
    setEditar(!editar);
    if (props.onClose) {
      props.onClose();
    }
  };

  const almacenar = (e) => {
    setDatosRow({
      ...datosRow,
      [e.target.name]: e.target.value,
    });
  };

  const EditarProducto = async (e) => {
    e.preventDefault();
    await fetch(UrlApi + "/envasado_productos/" + datosRow.id, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        codigo: datosRow.codigo,
        nombre: datosRow.nombre,
        peso: datosRow.peso,
        abreviatura: datosRow.abreviatura,
      }),
    })
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          // PONGO EL UPDATE EN TRUE PARA QUE LA TABLA SE ACTUALICE CON CADA ACTUALIZACION EN LOS DATOS
          setColorMensaje("#D4EFDF");
          setMensaje("El producto se editó exitosamente !");
          console.log("Guardado");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al editar el producto");
          console.log("Error");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  return (
    <>
      <Dialog
        fullWidth
        open={editar}
        onClose={() => handleClose()}
        maxWidth="xl"
      >
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Typography fontSize={20} align="center" color="#ffffff">
              Editar Producto {datosRow.id}
            </Typography>
          </DialogTitle>
        </Box>
        <form autoComplete="off" onSubmit={EditarProducto}>
          <DialogContent>
            <Grid container spacing={1}>
              <Grid item xs={3} py={1} mb={1}>
                <TextField
                  label="Código"
                  name="codigo"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 100,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.codigo}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={9} py={1} mb={1}>
                <TextField
                  label="Nombre"
                  name="nombre"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 100,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.nombre}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={6} py={1} mb={1}>
                <TextField
                  label="Peso"
                  name="peso"
                  size="small"
                  placeholder="..."
                  onKeyPress={(event) => {
                    if (!/[0-9.]/.test(event.key)) {
                      event.preventDefault();
                    }
                  }}
                  inputProps={{
                    maxLength: 10,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.peso}
                  onChange={almacenar}
                />
              </Grid>
              <Grid item xs={6} py={1} mb={1}>
                <TextField
                  label="Abreviatura"
                  name="abreviatura"
                  size="small"
                  placeholder="..."
                  inputProps={{
                    maxLength: 45,
                  }}
                  focused
                  required
                  fullWidth
                  value={datosRow.abreviatura}
                  onChange={almacenar}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              justifyContent="space-between"
              mt={1}
            >
              <Grid item>
                <Button
                  color="error"
                  variant="outlined"
                  onClick={() => handleClose()}
                  style={{ backgroundColor: "#fff" }}
                >
                  Volver
                </Button>
              </Grid>
              <Grid item>
                <Button type="submit" color="success" variant="contained">
                  Guardar
                </Button>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
      </Dialog>

      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default EdicionProducto;
